/* Bundle Builder JS Scaffold
 * Responsibilities: state management, selection handling, progress, summary, submit.
 */
(function(){
  const MONEY_FORMAT = window?.Shopify?.currency || {};

  function formatMoney(cents){
    if(window.formatMoney){ return window.formatMoney(cents, window.shopMoneyFormat || undefined); }
    return (cents/100).toLocaleString(undefined,{ style:'currency', currency: (MONEY_FORMAT.active || 'USD') });
  }

  const EVENT_PREFIX = 'bundle:';
  const emit = (root, name, detail={}) => root.dispatchEvent(new CustomEvent(EVENT_PREFIX+name,{ detail }));

  const BundleBuilder = {
    init(root){
      this.root = root;
      root.classList.remove('no-js');
      this.settings = this.parseSettings();
      this.cacheDom();
      this.state = this.buildInitialState();
      this.bindKitSizes();
      this.initSteps();
      // If a step has data-instructions, show that in place of the step title in the main area
      this.stepElements.forEach(el => {
        const instr = el.getAttribute('data-instructions');
        if(instr){
          const t = el.querySelector('.bundle-builder__step-title-text');
          if(t) t.textContent = instr;
        }
      });
  this.updateProgress();
  this.updateSummary();
      this.bindSubmit();
      // Default to the first kit size (e.g., 1-Box Kit) if available
      if(this.kitSizeButtons.length){
        const firstBtn = this.kitSizeButtons[0];
        if(firstBtn){
          // Simulate a click so all downstream state + UI updates run consistently
          firstBtn.click();
        }
      } else {
        // No kit sizes configured: render slots/visibility once in empty state
        this.stepElements.forEach((el, idx)=> this.adjustStepSlots(idx));
        const firstTitle = this.stepElements[0]?.querySelector('.bundle-builder__step-title');
        if(firstTitle){ firstTitle.classList.add('is-hidden'); }
        this.updateStepVisibility();
      }
  this.updateStepVisibility();
      emit(root,'readyToBuild');
    },
    parseSettings(){
      try { return JSON.parse(this.root.getAttribute('data-settings')); } catch(e){ return {}; }
    },
    cacheDom(){
      this.kitSizeButtons = Array.from(this.root.querySelectorAll('[data-kit-size-value]'));
      this.stepsWrapper = this.root.querySelector('[data-steps]');
      this.stepElements = Array.from(this.root.querySelectorAll('[data-step-id]'));
      this.submitBtn = this.root.querySelector('[data-submit]');
      this.summaryEl = this.root.querySelector('[data-summary]');
      this.summaryItemsEl = this.root.querySelector('[data-summary-items]');
      this.summaryTotalEl = this.root.querySelector('[data-summary-total]');
      this.progressBar = this.root.querySelector('[data-progress-bar]');
      this.progressText = this.root.querySelector('[data-progress-text]');
      this.statusEl = this.root.querySelector('[data-status]');
    },
    buildInitialState(){
      return {
        kitSize: null,
        steps: this.stepElements.map((el,i)=>({
          id: el.getAttribute('data-step-id'),
          productId: null,
          variantId: null,
          quantity: i === 0 ? 0 : 1, // first step gets kit size later
          required: true,
          optedOut: false,
          priceCents: 0,
          status: 'empty',
          imageSrc: null,
          variantOptions: [],
          productOrder: null,
          autoSelectSuppressed: false,
          // Per-step slot selections (step 0 = kit size slots, others = 1)
          slotSelections: [],
          slotChangeIndex: null
        })),
        submitting:false,
        errors:[]
      };
    },
    ensureVisible(el){
      if(!el) return;
      try {
        const rect = el.getBoundingClientRect();
        const topPad = 80; // space for sticky header
        const bottomPad = 20;
        const above = rect.top < topPad;
        const below = rect.bottom > (window.innerHeight - bottomPad);
        if(above || below){
          el.scrollIntoView({ behavior:'smooth', block:'nearest' });
        }
      } catch(_e){}
    },
    desiredSlotsForStep(index){
      // Step 0 depends on kit size; all other steps are single-slot
      return index === 0 ? (this.state.kitSize || 0) : 1;
    },
    adjustStepSlots(index){
      const stepEl = this.stepElements[index];
      const step = this.state.steps[index];
      const desired = this.desiredSlotsForStep(index);
      if(!Array.isArray(step.slotSelections)) step.slotSelections = [];
      if(desired <= 0){
        // No slots desired yet (e.g., no kit size chosen)
        step.slotSelections = [];
        this.renderStepSlots(stepEl, index);
        return;
      }
      // Preserve existing filled selections up to desired count
      const existing = step.slotSelections.slice(0, desired);
      // Grow to desired length with empty placeholders
      while(existing.length < desired){ existing.push({ productId:null, variantId:null, priceCents:0, imageSrc:null, title:null }); }
      step.slotSelections = existing;
      this.renderStepSlots(stepEl, index);
    },
    bindKitSizes(){
      if(!this.kitSizeButtons || !this.kitSizeButtons.length) return;
      this.kitSizeButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const value = parseInt(btn.getAttribute('data-kit-size-value')||'0', 10);
          if(!value || value < 0) return;
          // Toggle button states (radiogroup)
          this.kitSizeButtons.forEach(b => {
            const isActive = b === btn;
            b.setAttribute('aria-checked', isActive ? 'true' : 'false');
            b.classList.toggle('btn--primary', isActive);
            b.classList.toggle('btn--secondary', !isActive);
          });
          // Update state
          const previous = this.state.kitSize;
          this.state.kitSize = value;
          this.state.steps[0].quantity = value;
          // Reset step 0 slot selections when kit size changes
          if(previous !== value){
            const st0 = this.state.steps[0];
            st0.autoSelectSuppressed = true; // prevent immediate auto-pick in filters
            st0.slotSelections = [];
          }
          // Ensure slots match kit size and re-render
          this.adjustStepSlots(0);
          // UI updates (avoid writing a status message on kit size selection)
          // Reveal first step title now that kit size is chosen
          const firstTitleEl = this.stepElements[0]?.querySelector('.bundle-builder__step-title');
          if(firstTitleEl){ firstTitleEl.classList.remove('is-hidden'); }
          this.updateProgress();
          this.updateSummary();
          this.updateStepVisibility();
        });
      });
    },
    renderStepSlots(stepEl, index){
      if(!stepEl) return;
      const step = this.state.steps[index];
      const desired = this.desiredSlotsForStep(index);
      const grid = stepEl.querySelector('.bundle-step-products__grid');
      let slotsUl = stepEl.querySelector('[data-kit-slots]');
      if(!slotsUl){
        slotsUl = document.createElement('ul');
        slotsUl.className = 'bundle-builder__kit-slots';
        slotsUl.setAttribute('data-kit-slots','');
        const header = stepEl.querySelector('.bundle-builder__step-header');
        if(header && header.nextElementSibling){
          header.parentNode.insertBefore(slotsUl, header.nextElementSibling);
        } else {
          stepEl.appendChild(slotsUl);
        }
      }
      // Always show slots first; grid only opens on slot click or when needed
      if(grid) grid.hidden = true;
      slotsUl.innerHTML = '';
        if(!desired){ 
          slotsUl.hidden = true; 
          return; 
        }
      slotsUl.hidden = false;
      if(!Array.isArray(step.slotSelections)) step.slotSelections = [];
      if(step.slotSelections.length !== desired){ this.adjustStepSlots(index); return; }
      // No product-count based logic; numbering depends on slot count only
      step.slotSelections.forEach((sl, i) => {
        const li = document.createElement('li');
        li.className = 'bundle-builder__kit-slot';
        li.setAttribute('data-slot-index', String(i));
        if(sl && sl.productId){ li.setAttribute('data-product-id', String(sl.productId)); }
        if(sl && sl.title){ li.setAttribute('data-product-title', sl.title); }
        if(typeof sl?.priceCents === 'number'){ li.setAttribute('data-price-cents', String(sl.priceCents)); }
  // Per-step placeholder only
  const fallback = stepEl.getAttribute('data-placeholder-image');
        const imgSrc = this.normalizeImageUrl(sl?.imageSrc, 160) || fallback;
  const stepTitle = stepEl.getAttribute('data-step-title') || stepEl.querySelector('.bundle-builder__step-title')?.textContent?.trim() || 'Selection';
  const baseTitle = sl?.title || (sl?.productId ? this.getStepProductTitle(sl.productId) : null);
  const title = baseTitle || `Select ${stepTitle}${desired === 1 ? '' : ' ' + (i+1)}`;
        const variantMeta = sl?.variantTitle ? `<div class="bundle-builder__kit-slot-variant">${sl.variantTitle}</div>` : '';
  const hasSelection = !!sl?.variantId;
  if(!hasSelection){ li.classList.add('bundle-builder__kit-slot--empty'); }
        li.innerHTML = `
          <div class="bundle-builder__kit-slot-card" data-slot-open-grid="${i}" role="button" tabindex="0">
            <div class="bundle-builder__kit-slot-thumb">${imgSrc ? `<img src="${imgSrc}" alt="">` : ''}</div>
            <div class="bundle-builder__kit-slot-meta">
              <div class="bundle-builder__kit-slot-title">${title}</div>
              ${variantMeta}
              ${hasSelection ? `<a href="#" class="link link--sm bundle-builder__slot-change" data-slot-change="${i}">Change</a>` : ''}
            </div>
          </div>`;
        slotsUl.appendChild(li);
      });
      // Bind open-grid on slot click
      slotsUl.querySelectorAll('[data-slot-open-grid]').forEach(el => {
        el.addEventListener('click', (e)=>{
          const i = parseInt(el.getAttribute('data-slot-open-grid'),10);
          const st = this.state.steps[index];
          const hasAnySelection = Array.isArray(st.slotSelections) && st.slotSelections.some(sl => !!sl?.variantId);
          // First selection should bulk-fill all slots → don't target a single slot
          st.slotChangeIndex = hasAnySelection ? i : null;
          const gridEl = stepEl.querySelector('.bundle-step-products__grid');
          if(gridEl){ gridEl.hidden = false; this.ensureVisible(gridEl); }
        });
        // Keyboard accessibility for slot open (Enter/Space)
        el.addEventListener('keydown', (e)=>{
          const key = e.key || e.code;
          if(key === 'Enter' || key === ' ' || key === 'Spacebar'){
            e.preventDefault();
            el.click();
          }
        });
      });
    },
    applyPerStepProductFilters(){
      // For each step that has a kit → product position map, filter visible cards accordingly
      const kit = this.state.kitSize;
      this.stepElements.forEach((stepEl, stepIndex) => {
        if(stepEl.classList.contains('is-conditional-hidden')) return;
        const mapAttr = stepEl.getAttribute('data-kit-product-map');
        if(!mapAttr) return;
        // map format example: "2:1,3:2,4:3" (positions are 1-based)
        const mapping = {};
        mapAttr.split(',').forEach(pair => {
          const [kRaw, vRaw] = pair.split(':');
          const k = parseInt((kRaw||'').trim(),10);
          const v1 = parseInt((vRaw||'').trim(),10);
          if(!isNaN(k) && !isNaN(v1)){
            mapping[k] = v1 - 1; // store zero-based order
          }
        });
        if(!kit || !mapping.hasOwnProperty(kit)){
          // If no mapping for current kit, show all and let normal logic proceed
          stepEl.querySelectorAll('.bundle-product-card').forEach(card=> card.hidden=false);
          return;
        }
        const targetOrder = mapping[kit];
        const cards = Array.from(stepEl.querySelectorAll('.bundle-product-card'));
        let found = false;
        cards.forEach(card => {
          const order = parseInt(card.getAttribute('data-product-order')||'-1',10);
          if(order === targetOrder){ card.hidden = false; found = true; }
          else { card.hidden = true; }
        });
        // If the previously selected product is now hidden, clear this step selection state
        const stepState = this.state.steps[stepIndex];
        if(stepState.productId){
          const stillVisible = cards.find(c => !c.hidden && parseInt(c.getAttribute('data-product-id'),10) === stepState.productId);
          if(!stillVisible){
            stepState.productId = null;
            stepState.productOrder = null;
            stepState.variantId = null;
            stepState.priceCents = 0;
            stepState.status = 'empty';
            stepState.variantOptions = [];
            // Clear any aria-pressed on hidden cards
            cards.forEach(c => c.querySelector('[data-product-select]')?.setAttribute('aria-pressed','false'));
            this.updateSummary();
          }
        }
        // If target product index doesn't exist, hide the entire step and treat as non-required
        if(!found){
          stepEl.hidden = true;
          stepEl.classList.add('is-conditional-hidden');
        } else {
          // Auto-selection disabled for all steps; require explicit slot click
        }
      });
    },
    initSteps(){
      this.stepElements.forEach((stepEl,index) => {
        stepEl.querySelectorAll('[data-product-select]').forEach(cardBtn => {
          cardBtn.addEventListener('click', () => this.handleProductSelect(stepEl, cardBtn, index));
        });
        // Variant pickers
        stepEl.querySelectorAll('[data-variant-option]').forEach(sel => {
          sel.addEventListener('click', e => { e.stopPropagation(); });
          sel.addEventListener('change', (e) => { e.stopPropagation(); this.handleVariantChange(stepEl, index, e.target); });
        });
        // Initialize availability for each product card
        stepEl.querySelectorAll('.bundle-product-card').forEach(li => {
          try { this.refreshCardAvailability(li); } catch(_e){}
        });
        // Delegate Change buttons for slots (all steps)
        stepEl.addEventListener('click', (e)=>{
          const btn = e.target.closest('[data-slot-change]');
          if(!btn) return;
          e.preventDefault();
          e.stopPropagation();
          const i = parseInt(btn.getAttribute('data-slot-change'),10);
          if(isNaN(i)) return;
          const st = this.state.steps[index];
          st.slotChangeIndex = i;
          const grid = stepEl.querySelector('.bundle-step-products__grid');
          if(grid){ grid.hidden = false; this.ensureVisible(grid); }
        });

        // Opt-out checkbox
        const opt = stepEl.querySelector('[data-opt-out]');
        if(opt){
          opt.addEventListener('change', ()=>{
            const st = this.state.steps[index];
            st.optedOut = !!opt.checked;
            if(st.optedOut){
              // Clear any selection and hide grid/slots
              st.productId = null; st.productOrder = null; st.variantId = null; st.priceCents = 0; st.status = 'empty'; st.imageSrc = null; st.variantOptions = []; st.slotSelections = [];
              const grid = stepEl.querySelector('.bundle-step-products__grid'); if(grid) grid.hidden = true;
              const slots = stepEl.querySelector('[data-kit-slots]'); if(slots) slots.hidden = true;
            } else {
              // Re-render slots (especially for kit step) when opting back in
              this.adjustStepSlots(index);
            }
            this.updateProgress();
            this.updateSummary();
            this.updateStepVisibility();
          });
        }
      });
    },
    handleProductSelect(stepEl, cardBtn, index){
      // Route all steps through slot selection; non-kit steps have 1 slot
      const desired = this.desiredSlotsForStep(index);
      if(desired >= 1){
        return this.handleSlotProductSelect(stepEl, cardBtn, index);
      }
  const li = cardBtn.closest('.bundle-product-card');
  // Prevent selecting a fully unavailable card
  if(li && li.classList.contains('is-unavailable')) return;
      const productId = parseInt(li.getAttribute('data-product-id'),10);
  const productOrder = li.hasAttribute('data-product-order') ? parseInt(li.getAttribute('data-product-order'),10) : null;
  const multi = li.getAttribute('data-has-multi') === 'true';
      // Toggle off if already selected
      if(cardBtn.getAttribute('aria-pressed') === 'true'){
        const st = this.state.steps[index];
        st.autoSelectSuppressed = true;
        // Unpress and clear
        cardBtn.setAttribute('aria-pressed','false');
        st.productId = null;
        st.productOrder = null;
        st.variantId = null;
        st.priceCents = 0;
        st.status = 'empty';
        st.imageSrc = null;
        st.variantOptions = [];
  // Variant picker remains visible; no need to hide
        // No visual dimming; class toggling removed
        this.updateProgress();
        this.updateSummary();
        this.updateStepVisibility();
        emit(this.root,'stepClear',{ stepIndex:index });
        return;
      }
  // Clear previous selection visuals
  stepEl.querySelectorAll('[data-product-select]').forEach(b=>b.setAttribute('aria-pressed','false'));
      cardBtn.setAttribute('aria-pressed','true');
  // Dimming support removed
      const stepState = this.state.steps[index];
      stepState.productId = productId;
      stepState.productOrder = productOrder;
      stepState.imageSrc = this.getStepProductImageSrc(productId);
      if(!multi){
        // Guard: if single-variant product is unavailable, block
        const productJsonEl = li.querySelector('[data-product-json]');
        if(productJsonEl){
          try {
            const pd = JSON.parse(productJsonEl.textContent||'null');
            if(pd && Array.isArray(pd.variants) && pd.variants.length === 1 && !pd.variants[0].available){ return; }
          } catch(_e){}
        }
        const variantId = li.querySelector('[data-variant-id]')?.getAttribute('data-variant-id');
        stepState.variantId = variantId ? parseInt(variantId,10) : null;
        const priceCents = parseInt(li.querySelector('[data-price]')?.getAttribute('data-price-cents')||'0',10);
        stepState.priceCents = priceCents;
        stepState.status = 'selected';
        stepState.variantOptions = [];
  this.updateProgress();
        this.updateSummary();
        this.updateStepVisibility();
      } else {
        // Auto-select first available variant immediately
        const productJsonEl = li.querySelector('[data-product-json]');
        let productData;
        try { productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null; } catch(e){ productData = null; }
        if(productData && productData.variants && productData.variants.length){
          const firstAvailable = productData.variants.find(v=> v.available) || productData.variants[0];
          stepState.variantId = firstAvailable.id;
          stepState.priceCents = firstAvailable.price;
          stepState.status = 'selected';
          // Gather variant options from option1..3
          const pickedOptions = [];
            if(firstAvailable.option1) pickedOptions.push(firstAvailable.option1);
            if(firstAvailable.option2) pickedOptions.push(firstAvailable.option2);
            if(firstAvailable.option3) pickedOptions.push(firstAvailable.option3);
          stepState.variantOptions = pickedOptions;
          if(firstAvailable.featured_image && firstAvailable.featured_image.src){
            stepState.imageSrc = this.normalizeImageUrl(firstAvailable.featured_image.src,150);
          }
          // Reveal picker (now a sibling after button) and sync selects
          // Picker is always visible; sync selects
          const picker = li.querySelector('[data-variant-picker]');
          if(picker){
            const selects = picker.querySelectorAll('[data-variant-option]');
            pickedOptions.forEach((opt,i)=>{ if(selects[i]) selects[i].value = opt; });
          }
          this.updateProgress();
          this.updateSummary();
          this.updateStepVisibility();
          emit(this.root,'stepVariantSelect',{ stepIndex:index, variantId:firstAvailable.id, auto:true });
        } else {
          // Fallback: reveal picker if JSON missing
          const picker = li.querySelector('[data-variant-picker]');
          if(picker){ picker.querySelector('select')?.focus(); }
        }
      }
      emit(this.root,'stepSelect',{ stepIndex:index, productId });
    },
    handleSlotProductSelect(stepEl, cardBtn, index=0){
      const li = cardBtn.closest('.bundle-product-card');
      if(li && li.classList.contains('is-unavailable')) return;
      const productId = parseInt(li.getAttribute('data-product-id'),10);
      const productOrder = li.hasAttribute('data-product-order') ? parseInt(li.getAttribute('data-product-order'),10) : null;
      const multi = li.getAttribute('data-has-multi') === 'true';
      const desired = this.desiredSlotsForStep(index);
      if(desired <= 0){
        // Require kit size before allowing selection in step 1
        this.statusEl && (this.statusEl.textContent = 'Please choose a kit size first.');
        const grid = stepEl.querySelector('.bundle-step-products__grid');
        if(grid) grid.hidden = false; // ensure choices remain visible
        return;
      }
  let variantId = null, priceCents = 0, imageSrc = null, title = null, variantTitle = null;
      title = this.getStepProductTitle(productId);
      if(!multi){
        // Block selection if this single-variant product is out of stock
        const productJsonElSV = li.querySelector('[data-product-json]');
        if(productJsonElSV){
          try {
            const pd = JSON.parse(productJsonElSV.textContent||'null');
            if(pd && Array.isArray(pd.variants) && pd.variants.length === 1 && !pd.variants[0].available){ return; }
          } catch(_e){}
        }
        variantId = li.querySelector('[data-variant-id]')?.getAttribute('data-variant-id');
        variantId = variantId ? parseInt(variantId,10) : null;
        priceCents = parseInt(li.querySelector('[data-price]')?.getAttribute('data-price-cents')||'0',10);
        imageSrc = this.getStepProductImageSrc(productId);
      } else {
        const productJsonEl = li.querySelector('[data-product-json]');
        let productData; try { productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null; } catch(e){ productData = null; }
        if(productData && productData.variants && productData.variants.length){
          // Prefer the currently selected options in the variant picker if present
          let picked = null;
          const picker = li.querySelector('[data-variant-picker]');
          if(picker){
            const selects = picker.querySelectorAll('[data-variant-option]');
            if(selects.length){
              const selectedOptions = Array.from(selects).map(s=>s.value);
              picked = productData.variants.find(v => {
                const opts = [v.option1, v.option2, v.option3].filter(Boolean);
                return opts.length === selectedOptions.length && opts.every((opt,i)=> opt === selectedOptions[i]);
              }) || null;
            }
          }
          const chosen = picked || (productData.variants.find(v=> v.available) || productData.variants[0]);
          variantId = chosen.id;
          priceCents = chosen.price;
          imageSrc = (chosen.featured_image && chosen.featured_image.src)
            ? this.normalizeImageUrl(chosen.featured_image.src, 160)
            : this.getStepProductImageSrc(productId);
          const parts = [chosen.option1, chosen.option2, chosen.option3].filter(Boolean);
          const vt = parts.join(' / ').trim();
          variantTitle = vt && !/^default\s*title$/i.test(chosen.title||'') ? vt : null;
        }
      }
      const step = this.state.steps[index];
      if(!Array.isArray(step.slotSelections)) step.slotSelections = [];
      if(step.slotChangeIndex == null && !step.slotSelections.some(sl=> sl?.variantId)){
        step.slotSelections = Array.from({length: desired}, ()=> ({ productId, productOrder, variantId, priceCents, imageSrc, title, variantTitle }));
      } else {
        const idx = step.slotChangeIndex ?? 0;
        if(!step.slotSelections[idx]) step.slotSelections[idx] = {};
        step.slotSelections[idx] = { productId, productOrder, variantId, priceCents, imageSrc, title, variantTitle };
      }
      step.slotChangeIndex = null;
      const grid = stepEl.querySelector('.bundle-step-products__grid');
      if(grid) grid.hidden = true;
      this.renderStepSlots(stepEl, index);
      const allFilled = step.slotSelections.length === desired && step.slotSelections.every(sl=> !!sl.variantId);
      // Mirror last selection into aggregate fields for compatibility
      const last = step.slotSelections.findLast ? step.slotSelections.findLast(sl=> !!sl.variantId) : [...step.slotSelections].reverse().find(sl=> !!sl.variantId);
      if(last){
        step.productId = last.productId;
        step.productOrder = typeof last.productOrder === 'number' ? last.productOrder : productOrder;
        step.variantId = last.variantId;
        step.priceCents = last.priceCents;
        step.imageSrc = last.imageSrc;
        step.variantOptions = [];
      }
      step.status = allFilled ? 'selected' : 'empty';
      this.updateProgress();
      this.updateSummary();
      this.updateStepVisibility();
      emit(this.root,'stepSelect',{ stepIndex:index, productId });
    },
    handleVariantChange(stepEl,index, changedEl){
      const li = changedEl ? changedEl.closest('.bundle-product-card') : stepEl.querySelector('[aria-pressed="true"]')?.closest('.bundle-product-card');
      if(!li) return;
      const productOrder = li.hasAttribute('data-product-order') ? parseInt(li.getAttribute('data-product-order'),10) : null;
      const productJsonEl = li.querySelector('[data-product-json]');
      if(!productJsonEl) return;
      let productData; try { productData = JSON.parse(productJsonEl.textContent); } catch(e){ return; }
      // Build selected options array
      const selects = li.querySelectorAll('[data-variant-option]');
      const selectedOptions = Array.from(selects).map(s=>s.value);
      const variant = productData.variants.find(v => {
        const opts = [v.option1, v.option2, v.option3].filter(Boolean);
        if(opts.length !== selectedOptions.length) return false;
        return opts.every((opt,i)=> opt === selectedOptions[i]);
      });
      if(variant){
        const stepState = this.state.steps[index];
        const productId = parseInt(li.getAttribute('data-product-id'),10);
        const productOrder = li.hasAttribute('data-product-order') ? parseInt(li.getAttribute('data-product-order'),10) : null;
        const desired = this.desiredSlotsForStep(index);
        const parts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
        const vt = parts.join(' / ').trim();
        const variantTitle = vt && !/^default\s*title$/i.test(variant.title||'') ? vt : null;
        const imageSrc = (variant.featured_image && variant.featured_image.src) ? this.normalizeImageUrl(variant.featured_image.src, 160) : this.getStepProductImageSrc(productId);
        const title = this.getStepProductTitle(productId);

        // Mirror selection into step state (treat as selecting this product)
        stepState.productId = productId;
        stepState.productOrder = productOrder;
        stepState.variantId = variant.id;
        stepState.priceCents = variant.price;
        stepState.status = 'selected';
        stepState.variantOptions = selectedOptions.slice();
        stepState.imageSrc = imageSrc;

        // Apply to slots: bulk fill if first selection for this step, else target the chosen slot
        const st = this.state.steps[index];
        if(!Array.isArray(st.slotSelections)) st.slotSelections = [];
        const hasAny = st.slotSelections.some(sl => !!sl?.variantId);
        if(!hasAny && st.slotChangeIndex == null){
          st.slotSelections = Array.from({length: desired}, ()=> ({ productId, productOrder, variantId: variant.id, priceCents: variant.price, imageSrc, title, variantTitle }));
        } else {
          const targetIdx = typeof st.slotChangeIndex === 'number' ? st.slotChangeIndex : (st.slotSelections.length - 1);
          if(!st.slotSelections[targetIdx]) st.slotSelections[targetIdx] = {};
          st.slotSelections[targetIdx] = { productId, productOrder, variantId: variant.id, priceCents: variant.price, imageSrc, title, variantTitle };
        }
        st.slotChangeIndex = null;

        // Hide grid and re-render slots
        const grid = stepEl.querySelector('.bundle-step-products__grid');
        if(grid) grid.hidden = true;
        this.renderStepSlots(stepEl, index);
  this.updateProgress();
        this.updateSummary();
        this.updateStepVisibility();
        emit(this.root,'stepVariantSelect',{ stepIndex:index, variantId: variant.id });
      }
      // Refresh availability state and option disabling on this card
      try { this.refreshCardAvailability(li); } catch(_e){}
    },
    updateStepVisibility(){
      // Determine active steps considering conditional min kit size
      const activeIndices = [];
      const kitSize = this.state.kitSize || 0;
      // If no kit size chosen, hide all steps entirely
      if(!kitSize){
        this.stepElements.forEach((el, idx)=>{
          const st = this.state.steps[idx];
          if(st.status === 'selected'){
            st.status='empty'; st.productId=null; st.variantId=null; st.priceCents=0; st.slotSelections = [];
          }
          el.hidden = true;
          el.classList.add('is-conditional-hidden');
        });
        return;
      }
      this.stepElements.forEach((el,idx)=>{
        const min = parseInt(el.getAttribute('data-min-kit-size')||'0',10);
        // Dependency attributes
        const requiresStepIndex = el.getAttribute('data-requires-step-index');
        const requiresOrdersAttr = el.getAttribute('data-requires-product-orders');
        let dependencySatisfied = true;
        if(requiresStepIndex){
          const depIdx = parseInt(requiresStepIndex,10);
          const allowedOrders = requiresOrdersAttr ? requiresOrdersAttr.split(',').map(s=>parseInt(s.trim(),10)).filter(n=>!isNaN(n)) : [];
          const depState = this.state.steps[depIdx];
          if(!depState || depState.status !== 'selected'){
            dependencySatisfied = false;
          } else if(allowedOrders.length){
            // Determine if any selected slot (or the aggregate productOrder) matches allowed orders
            const orders = [];
            if(typeof depState.productOrder === 'number') orders.push(depState.productOrder);
            if(Array.isArray(depState.slotSelections)){
              depState.slotSelections.forEach(sl=>{ if(typeof sl?.productOrder === 'number') orders.push(sl.productOrder); });
            }
            if(!orders.length || !orders.some(o => allowedOrders.includes(o))){
              dependencySatisfied = false;
            }
          }
        }
        if(min && kitSize && kitSize < min){
          // Clear any previous selection if step becomes inactive
          const st = this.state.steps[idx];
          if(st.status === 'selected'){ st.status='empty'; st.productId=null; st.variantId=null; st.priceCents=0; }
          el.hidden = true;
          el.classList.add('is-conditional-hidden');
        } else if(!dependencySatisfied){
          const st = this.state.steps[idx];
          if(st.status === 'selected'){ st.status='empty'; st.productId=null; st.variantId=null; st.priceCents=0; }
          el.hidden = true;
          el.classList.add('is-conditional-hidden');
        } else {
          el.classList.remove('is-conditional-hidden');
          activeIndices.push(idx);
        }
      });
      // Apply progressive reveal among active steps: only the first incomplete is shown
      let firstIncompleteFound = false;
      activeIndices.forEach(idx => {
        const el = this.stepElements[idx];
        const stepState = this.state.steps[idx];
        const isSelected = this.isStepComplete(idx);
        // Ensure only one step (current or completed) is visible at a time depending on progression
        if(isSelected){
          el.hidden = false;
          el.classList.remove('is-locked');
          el.setAttribute('aria-current','false');
        } else if(!firstIncompleteFound){
          el.hidden = false;
          el.classList.remove('is-locked');
          el.setAttribute('aria-current','true');
          firstIncompleteFound = true;
        } else {
          el.hidden = true; // remain hidden until previous complete
          el.classList.add('is-locked');
          el.setAttribute('aria-current','false');
        }
        // Auto-selection disabled: require slot click to open product grid and pick variant
      });
      // Re-apply per-step product filters after visibility settles
      this.applyPerStepProductFilters();
    },
    isStepComplete(index){
      const s = this.state.steps[index];
      if(s.optedOut) return true; // treat as complete for progression
      if(Array.isArray(s.slotSelections)){
        const desired = this.desiredSlotsForStep(index);
        return desired > 0 && s.slotSelections.length === desired && s.slotSelections.every(sl=> !!sl.variantId);
      }
      return s.status === 'selected' && !!s.variantId;
    },
    computeDerived(){
      // Only count steps that are not conditionally hidden and not opted out
      const visibleIndices = this.state.steps.map((_,i)=>i)
        .filter(i=> !this.stepElements[i].classList.contains('is-conditional-hidden'))
        .filter(i=> !this.state.steps[i].optedOut);
      const completed = visibleIndices.filter(i=> this.isStepComplete(i)).length;
      const total = visibleIndices.length;
      const allRequired = completed === total && total>0;
      const totalPrice = this.state.steps.reduce((sum,s)=>{
        if(s.optedOut) return sum;
        if(Array.isArray(s.slotSelections) && s.slotSelections.length){
          return sum + s.slotSelections.reduce((acc,sl)=> acc + (sl.priceCents||0), 0);
        }
        return sum + (s.priceCents * (s.quantity||1));
      },0);
      return { completed, total, allRequired, totalPrice };
    },
    updateProgress(){
      const d = this.computeDerived();
      if(this.progressBar){
        const pct = d.total ? (d.completed / d.total)*100 : 0;
        this.progressBar.style.width = pct + '%';
      }
      if(this.progressText){
        this.progressText.textContent = d.completed < d.total ? `Step ${d.completed+1} of ${d.total}` : 'All steps complete';
      }
      if(this.submitBtn){ this.submitBtn.disabled = !d.allRequired; }
    },
    updateSummary(){
      if(!this.summaryItemsEl) return;
      const d = this.computeDerived();
      this.summaryItemsEl.innerHTML='';
      this.state.steps.forEach((s,i)=>{
        if(s.optedOut) return; // Skip opted-out steps
  const stepTitle = this.stepElements[i]?.getAttribute('data-step-title') || this.stepElements[i]?.querySelector('.bundle-builder__step-title')?.textContent?.trim() || `Step ${i+1}`;
        // Slot-based steps (e.g., kit step)
        if(Array.isArray(s.slotSelections) && s.slotSelections.length){
          const filled = s.slotSelections.filter(sl=> !!sl.variantId);
          if(!filled.length) return; // nothing selected yet for this step
          const qty = filled.length;
          const lineTotal = formatMoney(filled.reduce((acc,sl)=> acc + (sl.priceCents||0),0));
          const li=document.createElement('li');
          li.className='bundle-builder__summary-item';
          const thumbs = filled.map((sl, idx) => {
            const src = sl.imageSrc || s.imageSrc || '';
            if(!src) return '';
            return `<button type=\"button\" class=\"bundle-builder__summary-thumb\" data-summary-jump=\"${s.id}\" aria-label=\"Edit ${stepTitle} slot ${idx+1}\"><img src=\"${src}\" alt=\"\" loading=\"lazy\" /></button>`;
          }).join('');
          li.innerHTML = `
            <div class=\"bundle-builder__summary-step-title\">${stepTitle}${qty>1?` <small>x${qty}</small>`:''}</div>
            <div class=\"bundle-builder__summary-thumbs\">${thumbs}</div>
            <span class=\"bundle-builder__summary-line-total\">${lineTotal}</span>
            <button type=\"button\" class=\"bundle-builder__summary-remove\" data-summary-remove=\"${s.id}\" aria-label=\"Remove ${stepTitle}\">\n              <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\">\n                <path d=\"M9 3h6v2h5v2H4V5h5V3zm1 6h2v9h-2V9zm4 0h2v9h-2V9z\" fill=\"currentColor\"/>\n              </svg>\n            </button>`;
          this.summaryItemsEl.appendChild(li);
          return;
        }
        // Single-selection steps
        if(s.status === 'selected' && s.variantId){
          const productTitle = this.getStepProductTitle(s.productId) || '';
          const qty = s.quantity || 1;
          const lineTotal = formatMoney((s.priceCents||0) * qty);
          const imgSrc = s.imageSrc || this.getStepProductImageSrc(s.productId);
          const variantMeta = s.variantOptions && s.variantOptions.length ? `<span class="bundle-builder__summary-variant">${s.variantOptions.join(' / ')}</span>` : '';
          const li=document.createElement('li');
          li.className='bundle-builder__summary-item';
          li.innerHTML = `
            <div class="bundle-builder__summary-step-title">${stepTitle}</div>
            ${imgSrc ? `<button type="button" class="bundle-builder__summary-thumb" data-summary-jump="${s.id}" aria-label="Edit ${stepTitle}"><img src="${imgSrc}" alt="" loading="lazy" /></button>`:''}
            <span class="bundle-builder__summary-meta">
              ${productTitle ? `<span class=\"bundle-builder__summary-label\">${productTitle}</span>`:''}
              ${variantMeta}
            </span>
            <span class="bundle-builder__summary-line-total">${lineTotal}</span>
            <button type="button" class="bundle-builder__summary-remove" data-summary-remove="${s.id}" aria-label="Remove ${stepTitle}">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M9 3h6v2h5v2H4V5h5V3zm1 6h2v9h-2V9zm4 0h2v9h-2V9z" fill="currentColor"/>
              </svg>
            </button>`;
          this.summaryItemsEl.appendChild(li);
        }
      });
      if(this.summaryTotalEl){ this.summaryTotalEl.textContent = 'Subtotal: ' + formatMoney(d.totalPrice); }
      // Bind jump/edit handlers
      this.summaryItemsEl.querySelectorAll('[data-summary-jump]').forEach(btn => {
        btn.addEventListener('click', ()=>{
          const stepId = btn.getAttribute('data-summary-jump');
          this.jumpToStep(stepId);
        });
      });
      // Bind remove handlers
      this.summaryItemsEl.querySelectorAll('[data-summary-remove]').forEach(btn => {
        btn.addEventListener('click', ()=>{
          const stepId = btn.getAttribute('data-summary-remove');
          const index = this.state.steps.findIndex(s=> s.id === stepId);
          if(index >= 0){
            // Suppress auto-select so it doesn't immediately pick the only visible card again
            this.state.steps[index].autoSelectSuppressed = true;
            // Clear selection and update UI
            const st = this.state.steps[index];
            st.productId = null; st.productOrder = null; st.variantId = null; st.priceCents = 0; st.status='empty'; st.imageSrc=null; st.variantOptions=[]; st.slotSelections = [];
            const el = this.stepElements[index];
            if(el){
              el.querySelectorAll('[data-product-select]').forEach(b=> b.setAttribute('aria-pressed','false'));
              // Re-render step slots to show placeholders again
              this.adjustStepSlots(index);
            }
            this.updateProgress();
            this.updateSummary();
            this.updateStepVisibility();
          }
        });
      });
    },
    jumpToStep(stepId){
      const target = this.stepElements.find(el => el.getAttribute('data-step-id') === stepId);
      if(!target) return;
      target.hidden = false; // ensure visible
  this.ensureVisible(target);
      const heading = target.querySelector('.bundle-builder__step-title');
      heading && heading.focus && heading.focus();
    },
    getStepProductTitle(productId){
      if(!productId) return null;
      const card = this.root.querySelector(`.bundle-product-card[data-product-id="${productId}"] .bundle-product-card__title`);
      return card ? card.textContent.trim() : null;
    },
    getStepProductImageSrc(productId){
      if(!productId) return null;
      const img = this.root.querySelector(`.bundle-product-card[data-product-id="${productId}"] .bundle-product-card__media img`);
      return img ? img.getAttribute('src') : null;
    },
    normalizeImageUrl(src, width){
      if(!src) return src;
      // Shopify CDN pattern: append parameters if not already sized
      if(src.includes('_')) return src; // naive guard to avoid duplicating size tokens
      if(src.includes('?')) return src; // already parameterized
      return src.replace(/\.([^./?]+)$/, `_${width}x.$1`);
    },
    bindSubmit(){
      if(!this.submitBtn) return;
      this.submitBtn.addEventListener('click', ()=> this.handleSubmit());
    },
    handleSubmit(){
      const d = this.computeDerived();
      if(!d.allRequired || this.state.submitting) return;
      this.state.submitting = true;
      this.submitBtn.disabled = true;
      this.submitBtn.classList.add('is-loading');
      this.statusEl && (this.statusEl.textContent = 'Adding bundle...');
      // Build items only from visible (non-conditionally hidden) steps that are actually selected
      const items = [];
      for(let i=0;i<this.state.steps.length;i++){
        const stepEl = this.stepElements[i];
        const hiddenByCondition = stepEl && stepEl.classList.contains('is-conditional-hidden');
        const s = this.state.steps[i];
        if(hiddenByCondition || s.optedOut) continue;
        if(i===0 && Array.isArray(s.slotSelections) && s.slotSelections.length){
          s.slotSelections.forEach(sl => { if(sl.variantId){ items.push({ id: sl.variantId, quantity: 1 }); } });
        } else if(s.status === 'selected' && s.variantId){
          items.push({ id: s.variantId, quantity: 1 });
        }
      }
      if(!items.length){
        this.statusEl && (this.statusEl.textContent = 'Nothing to add. Please complete the steps.');
        this.submitBtn.classList.remove('is-loading');
        this.submitBtn.disabled = false;
        this.state.submitting = false;
        return;
      }
  // Tag items as part of a bundle using properties so we can detect/remove discount later
  const bundleId = `bb_${Date.now()}_${Math.random().toString(36).slice(2,8)}`;
  const expectedCount = items.length;
  const properties = { _bundle_id: bundleId, _bundle_expected_count: expectedCount };
  const payload = { items: items.map(it => ({...it, properties})) };
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, credentials:'same-origin', body: JSON.stringify(payload) })
        .then(r => {
          if(!r.ok) return r.json().then(j=> Promise.reject(j));
          return r.json();
        })
        .then(()=>{
          // Verify cart state and trigger theme cart UI refresh without full reload
          return fetch('/cart.js', { headers:{'Accept':'application/json'}, credentials:'same-origin', cache:'no-store' })
            .then(r=> r.ok ? r.json() : Promise.resolve(null))
            .then(cart => {
              if(cart && typeof cart.item_count === 'number' && cart.item_count > 0){
                this.statusEl && (this.statusEl.textContent = 'Bundle added to cart');
                // Apply discount code if configured
                if(this.settings && this.settings.discountCode){
                  this.applyCartDiscount(this.settings.discountCode).catch(()=>{});
                }
                // 1) Update header cart icon bubble via sections
                try {
                  fetch('?sections=cart-icon-bubble', { credentials:'same-origin' })
                    .then(res => res.ok ? res.json() : null)
                    .then(sections => {
                      if(sections && sections['cart-icon-bubble']){
                        const bubble = document.getElementById('cart-icon-bubble');
                        if(bubble) bubble.innerHTML = sections['cart-icon-bubble'];
                      }
                    });
                } catch(_e){}
                // 2) Refresh cart drawer contents and optionally open it
                const cartDrawer = document.querySelector('cart-drawer');
                if(cartDrawer){
                  try { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); } catch(_e){}
                  // Respect theme setting if available; default to open when theme says so
                  const shouldOpen = !!(window.theme && theme.settings && theme.settings.afterAtc === 'drawer');
                  if(shouldOpen){
                    try { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); } catch(_e){}
                  }
                }
                // 3) If on cart page, refresh items
                const cartRoute = (window.theme && theme.routes && theme.routes.cart) ? theme.routes.cart : '/cart';
                if(window.location.pathname === cartRoute){
                  const cartItemsEl = document.querySelector('cart-items');
                  if(cartItemsEl){
                    if(cartItemsEl.dataset.empty === 'true'){
                      window.location.reload();
                    } else if(typeof cartItemsEl.refresh === 'function'){
                      cartItemsEl.refresh();
                    }
                  }
                }
                // Back-compat custom event
                try { window.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } })); } catch(_e){}
                emit(this.root,'submitSuccess', { cart });
              } else {
                this.statusEl && (this.statusEl.textContent = 'Added, but cart looks empty. If you are previewing on a different domain, open the cart on the same domain.');
              }
              this.submitBtn.classList.remove('is-loading');
              this.submitBtn.disabled = false; // allow re-adding same config
              this.state.submitting = false;
            });
        })
        .catch(err => {
          const detail = err?.description || err?.message || (typeof err === 'string' ? err : null) || 'Failed to add bundle';
          this.statusEl && (this.statusEl.textContent = detail);
          try { console.error('Bundle add error', err); } catch(_e){}
          this.root.classList.add('bundle-builder--error');
          emit(this.root,'submitError',{ error: err });
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.disabled = false;
          this.state.submitting = false;
        });
    }
  };

  // Helpers for discount application and clearing
  BundleBuilder.applyCartDiscount = function(code){
    if(!code) return Promise.resolve();
    // Apply discount via GET (sets cookie); then refresh UI
    return fetch(`/discount/${encodeURIComponent(code)}`, { credentials:'same-origin' })
      .then(()=>{
        try { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); } catch(_e){}
        const cartItemsEl = document.querySelector('cart-items');
        if(cartItemsEl && typeof cartItemsEl.refresh === 'function') cartItemsEl.refresh();
      });
  };

  // Determine availability, mark card state, and disable OOS variant options
  BundleBuilder.refreshCardAvailability = function(li){
    if(!li) return;
    const jsonEl = li.querySelector('[data-product-json]');
    if(!jsonEl) return;
    let data; try { data = JSON.parse(jsonEl.textContent||'null'); } catch(_e){ return; }
    if(!data || !Array.isArray(data.variants)) return;
    const anyAvailable = data.variants.some(v => !!v.available);
    li.classList.toggle('is-unavailable', !anyAvailable);
    if(!anyAvailable){ li.setAttribute('data-unavailable','true'); }
    else { li.removeAttribute('data-unavailable'); }
    // Disable variant options that cannot lead to an available variant
    const selects = Array.from(li.querySelectorAll('[data-variant-option]'));
    if(!selects.length) return;
    const current = selects.map(s => s.value);
    selects.forEach((sel, idx) => {
      sel.querySelectorAll('option').forEach(opt => {
        const val = opt.value;
        const matches = data.variants.some(v => {
          if(!v.available) return false;
          const vOpts = Array.isArray(v.options) ? v.options : [v.option1, v.option2, v.option3].filter(Boolean);
          const cand = current.slice(); cand[idx] = val;
          return cand.every((c, i) => !c || vOpts[i] === c);
        });
        opt.disabled = !matches;
      });
      if(sel.selectedOptions && sel.selectedOptions[0] && sel.selectedOptions[0].disabled){
        const firstEnabled = sel.querySelector('option:not([disabled])');
        if(firstEnabled){ sel.value = firstEnabled.value; sel.dispatchEvent(new Event('change', { bubbles:true })); }
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-bundle-root]').forEach(root => {
      if(!root.__BUNDLE_INIT__){
        root.__BUNDLE_INIT__ = true;
        Object.create(BundleBuilder).init(root);
      }
    });
  });
})();
